import axios from '@/axios-api';
import Pathes from '@/helpers/pathes.js';
import { getQuery } from '@/helpers/utils';

export const chatwootService = {
  getIdentity: params => axios.get(Pathes.Common.chatwootIdentity + getQuery(params)),
};